import { PIN_LENGTH } from '@surglogs-app/util'

export const PIN_KEYS = ['pin-0', 'pin-1', 'pin-2', 'pin-3', 'pin-4', 'pin-5']

export const useSecurityPin = () => {
  const createPinConfig = () => ({
    pinLength: PIN_LENGTH,
    pinKeys: PIN_KEYS,
    pinArray: [0, 1, 2, 3, 4, 5],
    isSequenceExample: '(123456)',
    isRepetitiveExample: '(111111)',
  })

  return createPinConfig()
}
